import { useState } from "react"
import {
  type SubmitErrorHandler,
  type SubmitHandler,
  useForm,
} from "react-hook-form"
import Button from "@/components/Button"
import Input from "@/components/Input"
import validation from "@/libs/validation"
import * as styles from "@/styles/modules/SingleInputForm.module.scss"

interface SingleInputFormProps<T> {
  autoFocus?: boolean
  defaultValue?: string
  wrapperClass?: string
  submitBtnText: string
  onSubmit: SubmitHandler<T>
  onError: SubmitErrorHandler<T>
  loading?: boolean
  size?: "small" | "large"
}
const SingleInputForm = <FieldValues,>({
  autoFocus,
  defaultValue,
  wrapperClass,
  submitBtnText = "Submit",
  onSubmit,
  onError,
  loading,
  size = "large",
}: SingleInputFormProps<FieldValues>) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ mode: "onSubmit" })

  const [focused, setFocused] = useState(false)

  function handleFocus(e) {
    if (e.type === "focus") setFocused(true)
    if (e.type === "blur") setFocused(false)
  }

  return (
    <div
      className={`${styles.wrapper} ${focused ? styles.focused : ""} ${
        wrapperClass ? wrapperClass : ""
      } ${styles[size]}`}
    >
      <form
        className={styles.form}
        onSubmit={handleSubmit(onSubmit, onError ? onError : null)}
      >
        <Input
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          name="emailAddress"
          placeholder="Your email"
          register={register}
          validation={validation.email}
          errors={errors}
          inputWrapperClass={styles.inputWrapper}
          wrapperClass={styles.wrapper}
          onFocus={handleFocus}
          onBlur={handleFocus}
        />
        <Button
          className={styles.button}
          onFocus={handleFocus}
          onBlur={handleFocus}
          size={size}
          loading={loading}
        >
          {submitBtnText}
        </Button>
      </form>
    </div>
  )
}

export default SingleInputForm
